export default __webpack_public_path__ + "static/media/icon1_blue.5a7b294b.svg";